import React, { useState } from 'react';
import Button from '../../components/common/Button';
import { useEscapeToClose } from '../../hooks/useEscapeToClose';
import { AdminSubmission, DeleteSubmissionResult, deleteSubmission, errorMessage, ownerLabel } from '../../services/manageApi';
import '../../components/Auth/RegisterModal.css';

interface Props {
  competitionId: number;
  submission: AdminSubmission;
  onClose: () => void;
  onDeleted: (result: DeleteSubmissionResult) => void;
}

const DeleteSubmissionDialog: React.FC<Props> = ({ competitionId, submission, onClose, onDeleted }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEscapeToClose(onClose, { enabled: !busy });

  const submit = async () => {
    setBusy(true);
    setError('');
    try {
      onDeleted(await deleteSubmission(competitionId, submission.submission_id));
    } catch (err) {
      setError(errorMessage(err, 'Failed to delete the submission'));
      setBusy(false);
    }
  };

  return (
    <div className="register-modal-backdrop">
      <div className="register-modal" role="dialog" aria-modal="true" aria-labelledby="delete-submission-title">
        <div className="register-modal__header">
          <h2 className="register-modal__title" id="delete-submission-title">Delete submission</h2>
        </div>
        <div className="register-modal__form">
          <p>
            Delete <strong>{ownerLabel(submission)}</strong>&apos;s submission
            {submission.version != null && <> (v{submission.version})</>}? <strong>This cannot be undone.</strong>
          </p>
          <ul className="danger-dialog__list">
            <li>{submission.votes} vote(s), {submission.manual_scores} manual score(s) and {submission.rubric_evaluations} rubric evaluation(s) involving it are deleted, and judges get those votes back.</li>
            <li>ELO ratings are recalculated from the remaining votes.</li>
            <li>All of its stored files (including practice-run files) are removed. They can submit again from version 1.</li>
          </ul>
          {error && <div className="register-modal__error" role="alert">{error}</div>}
          <div className="register-modal__actions">
            <Button variant="secondary" onClick={onClose} disabled={busy} autoFocus>Cancel</Button>
            <Button variant="danger" onClick={submit} loading={busy} disabled={busy}>Delete submission</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteSubmissionDialog;
